export default __webpack_public_path__ + "static/media/014.57f86eea.jpg";